import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {AuthContextProvider} from "./components/Auth/AuthContext";
import {ToastProvider} from "./components/Toast";
import {RecoilRoot} from "recoil";
import {Theme} from "@carbon/react";
import RecoilNexus from "recoil-nexus";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RecoilRoot>
    <RecoilNexus />
    <AuthContextProvider>
      <ToastProvider>
        <Theme theme="g10">
          <App />
        </Theme>
      </ToastProvider>
    </AuthContextProvider>
  </RecoilRoot>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
